module.exports = __webpack_public_path__ + "static/img/pingjie6.faa4c663.png";